import Vue from 'vue'
import App from './App'
import util from './utils/util'
import router from './router'
// import mavonEditor from 'mavon-editor'//
import 'mavon-editor/dist/css/index.css'
import 'mavon-editor/dist/markdown/github-markdown.min.css'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 20200506 tz add start
import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'
import Highchart from "highcharts/highcharts"
import HighchartsVue from 'highcharts-vue'
import stockInit from "highcharts/modules/stock"
import exportingInit from 'highcharts/modules/exporting'
//引入样式文件
import 'leaflet/dist/leaflet.css'
//引入Leaflet对象 挂载到Vue上，便于全局使用，也可以单独页面中单独引用
import * as L from 'leaflet'
import dataV from '@jiaminghi/data-view'
// 20200506 tz add end

import 'video.js/dist/video-js.css'

// import Vant from 'vant'
// import 'vant/lib/vant-css/index.css'
import Cookie from 'js-cookie'
Vue.prototype.$cookie = Cookie

//add by lcc 2021-2-28 start
import 'video.js/dist/video-js.css'
import hls from 'videojs-contrib-hls'
import VueVideoPlayer from 'vue-video-player'
import 'videojs-flash'

Vue.use(hls)
Vue.use(VueVideoPlayer)


//add by lcc 2021-2-28 end
// Vue.use(Vant)
Vue.use(ElementUI)
// Vue.use(mavonEditor)
Vue.use(dataV)

// 20200506 tz add start
stockInit(Highchart)
exportingInit(Highchart)
Vue.use(HighchartsVue)
Vue.L = Vue.prototype.$L = L
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
// 20200506 tz add end

Vue.prototype.$markdown = function (value) {
    return mavonEditor.markdownIt.render(value)
}

Vue.prototype.$reload = function (context) {
    let NewPage = '/empty'
    context.$router.push(NewPage)
    context.$nextTick(() => (context.$router.go(-1)))
}

// Vue.prototype.$setTitle = function (title) {
//     if (title) {
//         document.title = store.state.configuration.htmlTitle + " - " + title
//     } else {
//         document.title = store.state.configuration.htmlTitle
//     }
// }
Vue.prototype.$share = function (message) {
    if (!message) {
        message = window.location
    } else {
        let arr = (window.location + "").split("#")
        message = arr[0] + "#" + message
    }
    if (util.copy(message)) {
        Vue.prototype.$confirm('链接已复制,去分享给好友吧!!', '分享', {
            showCancelButton: false,
            showClose: false,
            type: 'success'
        })
    } else {
        Vue.prototype.$confirm('链接复制失败,可能因为浏览器不兼容', '分享', {
            showCancelButton: false,
            showClose: false,
            type: 'warning'
        })
    }
}

Vue.prototype.$mobileShare = function (message) {
    if (!message) {
        message = window.location
    } else {
        let arr = (window.location + "").split("#")
        message = arr[0] + "#" + message
    }
    if (util.copy(message)) {
        Vue.prototype.$dialog.alert({
            title: '分享',
            message: '链接已复制,去分享给好友吧!!'
        })
    } else {
        Vue.prototype.$dialog.alert({
            title: '分享',
            message: '链接复制失败,可能因为浏览器不兼容'
        })
    }
}



Vue.prototype.$util = util

Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js